export default __webpack_public_path__ + "static/media/20.2db84ec2.png";